var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "text-xs-center": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-3",
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.media')) + "\n      ")]), _c('v-spacer')], 1), _c('video', {
    ref: "video",
    class: {
      flash: _vm.flashOn
    }
  }), !_vm.isCameraReady ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm.media == 'photo' && _vm.isCameraReady ? _c('v-card', {
    class: {
      'mr-3 mt-3 captureButton': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3 mt-3 captureButton': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "pink darken-2"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.capture.apply(null, arguments);
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("photo_camera")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.takePicture')) + "\n        ")])], 1)], 1) : _vm._e(), _vm.media == 'video' && _vm.isCameraReady ? _c('v-card', {
    class: {
      'mr-3 mt-3 captureButton': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3 mt-3 captureButton': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "deep-purple darken-2"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.startRecord.apply(null, arguments);
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("videocam")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.recordVideo')) + "\n        ")])], 1)], 1) : _vm._e(), _vm.media == 'recording' ? _c('v-card', {
    class: {
      'mr-3 mt-3 captureButton': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3 mt-3 captureButton': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "red darken-2"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.stopRecord.apply(null, arguments);
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("stop")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.stopRecord')) + "\n        ")])], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }